import type * as ActionCable from '@rails/actioncable'

import type { FullSocketConfig } from '../lib/socketMatcher'
import type { Events } from '../lib/updateRowInQueries'
import type { Any } from '@api/orvalFetcher'
import type { AppDispatch } from '@store/store'

export type ID = number | string

export type WSPayload = {
  event: Events
  event_key: string
  data: Any & { id: ID }
}

export type Handler = (payload: WSPayload) => void
export type HandlersSet = Set<Handler>
export type Cleanup = () => void

export type ConnectionEntry = {
  consumer: ActionCable.Consumer
  subscription: ActionCable.Subscription
  wsUrl: string
  /** Subscription identifier string (as used by ActionCable). */
  identifier: string
  /** Cleaned browser path used to compute identifier/onConnect behavior. */
  path: string
}

export type ConsumerCacheEntry = {
  consumer: ActionCable.Consumer
  refCount: number
}

// --- Internal State ---

export let socketConfigs: Array<FullSocketConfig> = []
export let reduxDispatch: AppDispatch | undefined

/** Map of socket name -> connection details */
export const activeConnections = new Map<string, ConnectionEntry>()

/** Map of socket name -> event name -> set of handlers */
export const eventHandlers = new Map<string, Map<string, HandlersSet>>()

/** Map of socket name -> onConnect cleanup function */
export const connectionCleanups = new Map<string, Cleanup | undefined>()

/** Cache of consumers by wsUrl to share physical connections */
export const consumerCache = new Map<string, ConsumerCacheEntry>()

// --- State Setters ---

export const setSocketConfigs = (configs: Array<FullSocketConfig>) => {
  socketConfigs = [...configs]
}

export const setReduxDispatch = (dispatch: AppDispatch) => {
  reduxDispatch = dispatch
}
